// import

import type {SupportMainNode, SupportNode} from '@arc/hub-model';

import {styled} from '@linaria/react';

import {AppLink} from 'modules/App';
import {Link} from 'modules/Link';
import {Type} from 'modules/Type';

import Gumballs from '../../public/image/gumballs.svg';

import {SupportMainSeo} from './SupportMainSeo';

// types

type Props = {
  main: SupportMainNode;
  supports: Array<Pick<SupportNode, 'meta'>>;
};

// component

export function SupportMainPage(props: Props) {
  const {main, supports} = props;
  const {meta: {head}} = main;

  return (
    <Block>
      <SupportMainSeo main={main} supports={supports} />

      <div className="inner">
        <div className="media">
          <Gumballs
            aria-label="Questions and answers in every flavor!"
            className="image"
            tabIndex={0} />
        </div>

        <Type className="content">
          <h1 className="title">{head.headline}</h1>

          <ul className="list" data-test="support-quick">
            {supports.map((n) => (
              <li key={n.meta.slug}>
                <Link href={n.meta.link}>{n.meta.title}</Link>
              </li>
            ))}
          </ul>

          <AppLink className="button yellow" href="/contact">
            <div className="contactHook">{head.contactHook}</div>
            <div className="contactText">{head.contactText}</div>
          </AppLink>
        </Type>
      </div>
    </Block>
  );
}

// styles

const Block = styled('section')`
padding: 6rem 1rem;
position: relative;

.inner {
  margin: 6rem auto 0;
  max-width: var(--bp-sm);
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: stretch;
  gap: 3rem;
}

.media {
  flex: 0 1 15rem;
}

.image {
  display: block;
  width: 100%;
  height: auto;
}

.content {
  flex: 1 0 auto;
  display: flex;
  flex-flow: column nowrap;
  padding: 1rem 0 2rem;
}

.list {
  flex: 1 1 auto;
}

.button.yellow {
  display: block;
  text-align: center;
  line-height: 1.5rem;
  padding: 1rem;

  & .contactText {
    font-size: 1.25rem;
    font-weight: 500;
  }
}

@media (max-width: 35.99875em) {
  .inner {
    flex-flow: column nowrap;
  }

  .image {
    max-width: 12rem;
    margin: 0 auto;
  }

  .content {
    display: block;
    width: 100%;
    padding: 0;
  }

  .list {
    flex: 0 0 auto;
  }

  .button.yellow {
    display: block;
    margin: 0 auto;
  }
}
`;
